module.exports = __webpack_public_path__ + "static/media/TW_Newsletter-image2.a0faf9c7.jpg";